export default "__VITE_ASSET__BTWntHA5__"